import { stateServiceProxy } from '../servicePool';

export function getAll(text = '', callback = null) {
  return stateServiceProxy.searchStates(100, text);
}
